import React from 'react';
import {RegulatoryReferencePickerComponentProps} from './RegulatoryReferencePickerTypes';
import {
	IconButtonCompat as IconButton,
	TooltipHostCompat as TooltipHost,
} from 'components/FluentUICompat';

export const RegulatoryReferencePickerDeleteButton = (
	props: RegulatoryReferencePickerComponentProps,
) => {
	const {state, index, setState, setInternalValue, remove, t} = props;
	return (
		<TooltipHost content={t('ToolTipDelete')}>
			<IconButton
				styles={{
					root: {marginTop: 28},
				}}
				iconProps={{iconName: 'Delete'}}
				onClick={() => {
					const sections = [...state.sections];
					sections.splice(index, 1);
					setState({
						...state,
						sections,
					});
					setInternalValue(`regulatories[${index}].regulation`, undefined);
					setInternalValue(
						`regulatories[${index}].regulatoryDocuments`,
						undefined,
					);
					remove(index);
				}}
			/>
		</TooltipHost>
	);
};
